var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMvMaldives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 11.25H11.25V33.75H48.75V11.25Z",
    fill: "#007E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 30C23.0454 30 19.6875 26.6421 19.6875 22.5C19.6875 18.3579 23.0454 15 27.1875 15C31.3296 15 34.6875 18.3579 34.6875 22.5C34.6875 26.6421 31.3296 30 27.1875 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 30C20.2329 30 16.875 26.6421 16.875 22.5C16.875 18.3579 20.2329 15 24.375 15C28.5171 15 31.875 18.3579 31.875 22.5C31.875 26.6421 28.5171 30 24.375 30Z",
    fill: "#007E3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvMaldives);
export default __webpack_public_path__ + "static/media/mv Maldives.d6035d5d40db2cfcbdfa6f4233b5185c.svg";
export { ForwardRef as ReactComponent };